import { render, staticRenderFns } from "./BlockGreeting.vue?vue&type=template&id=753a1d3e&"
import script from "./BlockGreeting.vue?vue&type=script&lang=js&"
export * from "./BlockGreeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports